<template>
    <div class="revshare">
        <div class="card">
            <div class="card__header">
                <div>
                    <h4 class="card__title revshare__title">Приглашайте друзей и зарабатывайте</h4>
                    <p class="revshare__subtitle">Делитесь ссылкой и зарабатывайте <strong>{{ commission }}%</strong> от преимущества казино</p>
                    <p class="revshare__subtitle">Подробнее о реферальной системе <a target="_blank" href="https://protraffic.com/baza-znaniy/model-oplaty-revshare-revshara-kak-s-nej-ra-3713.html">здесь</a></p>
                    <small class="small text-muted">
                        Для увеличения <strong>% реферальной системы</strong> напишите менеджеру: <a target="_blank" :href="$root.$link.manager">{{ $root.$link.manager_username }}</a> (поднимаем до 70%)
                    </small>
					<h5 class="card__title revshare__title"><small><b>Ваша ссылка</b></small></h5>
					<div class="revshare__copy-field" v-if="user !== null">
						<CopyField :text="$root.$refhost +'/r/' + user.id" outline/>
					</div>
                </div>
            </div>
            <div class="card__body">
				<nav class="revshare__nav-line nav-line">
					<a class="nav-line__item active">RevShare</a>
					<router-link :to="{name: 'promocodes'}" class="nav-line__item">
						Промокоды
					</router-link>
					<router-link
						v-if="user && (user.is_admin || user.can_transfer)"
						:to="{name: 'transfer'}"
						class="nav-line__item">
						Переводы
					</router-link>
					<router-link
						v-if="user && (user.is_admin || user.max_loan)"
						:to="{name: 'loan'}"
						class="nav-line__item">
						Кредит
					</router-link>
				</nav>

				<div class="fields" v-if="referrers.length">
					<div class="fields__item revshare__filter">
						<div class="revshare__filter-date">
							<VueDatePicker
								class="datepicker"
								v-model="date"
								placeholder="Период"
								range
								format="dd.MM.yyyy"
								auto-apply
								locale="ru"
								:enable-time-picker="false"
								@update:model-value="handlerSetPeriod"
							/>
						</div>
						<button @click="getRangeStats(start, end);currentRange = '';" class="revshare__filter-btn btn btn--primary">
							Показать
						</button>
					</div>
					<div class="fields__item revshare__btns">
						<button v-for="(item, index) in rangeOptions"
								:class="{ 'active': currentRange == index }"
								:disabled="currentRange == index"
								@click="getStatsForRange(index)"
								class="revshare__btn btn btn--primary btn--xs">
							{{ item }}
						</button>
					</div>
					<div class="fields__item">
						<div class="revshare__grid">
							<div class="revshare__card"
								 @click="takeProfit"
								 :class="{
									'active': can_take_profit,
									'disabled': !can_take_profit
							 	}">
								<div class="revshare__card-label"
									 :class="{
										'text-muted': !can_take_profit,
										'text-white': can_take_profit
									}">
									Баланс RevShare
								</div>
								<div class="revshare__card-value"
									 :class="{
										'success': profit > 0 && !can_take_profit,
										'danger': profit < 0,
										'white': can_take_profit || profit === 0
									}">
									{{ $root.shortLargeNumber(profit) }}
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Рефералов</div>
								<div class="revshare__card-value">
									{{ stats.total.referrers }}
									<small class="revshare__card-count success" v-if="stats.range.referrers">
										+{{ stats.range.referrers }}
									</small>
									<small class="revshare__card-count muted" v-else>
										{{ stats.range.referrers }}
									</small>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Получено</div>
								<div class="revshare__card-value"
                                    :class="{ 'success': received_total_profit > 0 }">
										{{ $root.shortLargeNumber(received_total_profit) }}
									<span class="revshare__card-count success" v-if="received_range_profit > 0">
										+{{ $root.shortLargeNumber(received_range_profit) }}
									</span>
									<span class="revshare__card-count muted" v-else>
										{{ $root.shortLargeNumber(received_range_profit) }}
									</span>
									<button class="revshare__card-info" @click="activeModal = 'revshareReceivedProfitModal'" type="button">
										<svg class="revshare__card-info-icon"><use href="#svg-icon-help"></use></svg>
									</button>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Доход</div>
								<div class="revshare__card-value"
									:class="{
										'success': stats.total.profit > 0,
										'danger': stats.total.profit < 0
									}">
										{{ $root.shortLargeNumber(stats.total.profit) }}
									<span class="revshare__card-count success" v-if="stats.range.profit > 0">
										+{{ $root.shortLargeNumber(stats.range.profit) }}
									</span>
									<span class="revshare__card-count muted" v-else-if="stats.range.profit == 0">
										{{ $root.shortLargeNumber(stats.range.profit) }}
									</span>
									<span class="revshare__card-count danger" v-else-if="stats.range.profit < 0">
										{{ $root.shortLargeNumber(stats.range.profit) }}
									</span>
									<button class="revshare__card-info" @click="activeModal = 'revshareProfitModal'" type="button">
										<svg class="revshare__card-info-icon"><use href="#svg-icon-help"></use></svg>
									</button>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Комиссии</div>
								<div class="revshare__card-value">
									{{ $root.shortLargeNumber(stats.total.commissions) }}
									<span class="revshare__card-count success" v-if="stats.range.commissions < 0">
										{{ $root.shortLargeNumber(stats.range.commissions) }}
									</span>
									<span class="revshare__card-count muted" v-else-if="stats.range.commissions == 0">
										{{ $root.shortLargeNumber(stats.range.commissions) }}
									</span>
									<span class="revshare__card-count danger" v-else-if="stats.range.commissions > 0">
										+{{ $root.shortLargeNumber(stats.range.commissions) }}
									</span>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Балансы</div>
								<div class="revshare__card-value">
									{{ $root.shortLargeNumber(stats.total.balance) }}
									<button class="revshare__card-info" @click="activeModal = 'revshareBalanceModal'" type="button">
										<svg class="revshare__card-info-icon"><use href="#svg-icon-help"></use></svg>
									</button>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Депозиты</div>
								<div class="revshare__card-value">
									{{ $root.shortLargeNumber(stats.total.payments) }}
									<span class="revshare__card-count success" v-if="stats.range.payments">
										+{{ $root.shortLargeNumber(stats.range.payments) }}
									</span>
									<span class="revshare__card-count muted" v-else>
										{{ $root.shortLargeNumber(stats.range.payments) }}
									</span>
								</div>
							</div>
							<div class="revshare__card">
								<div class="revshare__card-label">Выводы</div>
								<div class="revshare__card-value">
									{{ $root.shortLargeNumber(stats.total.withdraws) }}
									<small class="revshare__card-count success" v-if="stats.range.withdraws">
										+{{ $root.shortLargeNumber(stats.range.withdraws) }}
									</small>
									<small class="revshare__card-count muted" v-else>
										{{ $root.shortLargeNumber(stats.range.withdraws) }}
									</small>
								</div>
							</div>
						</div>
					</div>

					<div v-if="loan" class="fields__item alert alert--warning small">
						<span>
                        	У вас есть незакрытые кредиты на сумму: <strong>{{ loan }}</strong> ₽.
						</span>
						<div v-if="can_take_profit">
							При снятии RevShare, <strong>{{ profit >= loan ? loan : profit }}</strong> ₽ будет списано в качестве оплаты кредита.
						</div>
					</div>

					<div class="fields__item small text-muted" v-if="captured_at">
						Данная информация актуальна на:
						<strong>
							{{ $root.moment(captured_at).format('YYYY-MM-DD, HH:mm:ss') }}
						</strong>
					</div>

					<ul v-if="last_page > 1" class="fields__item pagination">
						<li v-for="(link) in pagenav_links" class="pagination__item">
							<span class="pagination__item-link"
								v-if="link.active || link.url || link.label === '...'"
								:class="{
									'active': link.active,
									'disabled': ! link.url
								}"

								@click="goToPage(link.url)"
								v-html="link.label"
							></span>
						</li>
					</ul>

					<Loader v-show="isLoading" class="revshare__loader" :loading="isLoading" static/>

					<div class="table-wrap" v-show="!isLoading">
						<table class="table table--bordered text-center">
							<thead>
								<tr>
									<th :class="{
											'sorting': sort.field !== 'user_id',
											'sorting_asc': sort.field === 'user_id' && !sort.desc,
											'sorting_desc': sort.field === 'user_id' && sort.desc
										}"
										@click="doSort('user_id')">
										ID
									</th>
									<th :class="{
											'sorting': sort.field !== 'username',
											'sorting_asc': sort.field === 'username' && !sort.desc,
											'sorting_desc': sort.field === 'username' && sort.desc
										}"
										@click="doSort('username')">
										Логин
									</th>
									<th :class="{
											'sorting': sort.field !== 'register_date',
											'sorting_asc': sort.field === 'register_date' && !sort.desc,
											'sorting_desc': sort.field === 'register_date' && sort.desc
										}"
										@click="doSort('register_date')">
										Регистрация
									</th>
									<th :class="{
											'sorting': sort.field !== 'payments',
											'sorting_asc': sort.field === 'payments' && !sort.desc,
											'sorting_desc': sort.field === 'payments' && sort.desc
										}"
										@click="doSort('payments')">
										Депозиты
									</th>
									<th :class="{
											'sorting': sort.field !== 'withdraws',
											'sorting_asc': sort.field === 'withdraws' && !sort.desc,
											'sorting_desc': sort.field === 'withdraws' && sort.desc
										}"
										@click="doSort('withdraws')">
										Выводы
									</th>
									<th :class="{
											'sorting': sort.field !== 'commissions',
											'sorting_asc': sort.field === 'commissions' && !sort.desc,
											'sorting_desc': sort.field === 'commissions' && sort.desc
										}"
										@click="doSort('commissions')">
										Комиссии
									</th>
									<th :class="{
											'sorting': sort.field !== 'balance',
											'sorting_asc': sort.field === 'balance' && !sort.desc,
											'sorting_desc': sort.field === 'balance' && sort.desc
										}"
										@click="doSort('balance')">
										Баланс
									</th>
									<th :class="{
											'sorting': sort.field !== 'profit',
											'sorting_asc': sort.field === 'profit' && !sort.desc,
											'sorting_desc': sort.field === 'profit' && sort.desc
										}"
										@click="doSort('profit')">
										Доход
									</th>
								</tr>
							</thead>
							<tbody class="text-center nowrap">
								<tr v-for="(referrer) in referrers">
									<td>{{ referrer.user_id }}</td>
									<td>{{ referrer.username }}</td>
									<td>{{ referrer.register_date }}</td>
									<td>
										{{ $root.currency(referrer.payments) }}
									</td>
									<td >
										{{ $root.currency(referrer.withdraws) }}
									</td>
									<td>
										{{ $root.currency(referrer.commissions) }}
									</td>
									<td>
										{{ $root.currency(referrer.balance) }}
									</td>
									<td>
										{{ $root.currency(referrer.profit) }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<Modal :open-state="!!activeModal" @close="() => activeModal = null" dialog-class="modal--md">
						<div v-if="activeModal === 'revshareBalanceModal'">
							Данный баланс это сумма всех балансов и незакрытых игр ваших рефералов. <br/>
							С уменьшением или увеличением баланса ваших рефералов ваш доход может увеличиваться или уменьшаться соответственно.
						</div>
						<div v-if="activeModal === 'revshareReceivedProfitModal'">
							Получено = Доход – Баланс RevShare
						</div>
						<div v-if="activeModal === 'revshareProfitModal'">
							<strong>Формула расчета прибыли:</strong> (Депозиты – Выводы – Комиссии – Балансы)×{{ commission }}%<br/>
							<strong>Расчёт комиссии:</strong> 10% с депозитов + 10% с разницы выигрышных и проигрышных ставок игроков
						</div>
					</Modal>
				</div>
				<div v-else class="text-center">
					<h4>На текущий момент у вас нету реферралов.</h4>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import VueDatePicker from '@vuepic/vue-datepicker';
	import Modal from "../../components/blocks/Modal.vue";
	import CopyField from "../../components/blocks/CopyField.vue";
	import Loader from "../../components/blocks/Loader.vue";

    const DEFAULT_FIELD = 'profit';
    const DEFAULT_DIRECTION_DESC = true;

    export default {
		components: {
			Loader,
			CopyField,
			Modal,
			VueDatePicker
		},

        data() {
            return {
                domain: window.location.origin,
                showList: true,
                referrers: [],
                commission: 0,
                sort: {
                    'field': DEFAULT_FIELD,
                    'desc': DEFAULT_DIRECTION_DESC        
                },
                page: 1,
                current_page: null,
                last_page: null,
                pagenav_links: [],
                stats: {
                    range: {},
                    total: {}
                },
                received_total_profit: 0,
                received_range_profit: 0,
                captured_at: null,
                can_take_profit: false,
                profit: 0,
                loan: null,
                isLoading: true,
                currentRange: 'today',
                rangeOptions: {
                    yesterday: 'Вчера',
                    today: 'Сегодня',
                    week: 'Неделя',
                    month: 'Месяц'
                },
				date: null,
                start: null,
                end: null,
				activeModal: null
            }
        },
		mounted() {
            this.$root.isLoading = true;

            if (!this.$cookie.get('token')) {
                this.$root.isLoading = false;
                this.$router.go(-1);
            }
            this.getStats();
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            getInfo() {
                this.$root.axios.post('/api/referrals/list', {
                    'page': this.page,
                    'field': this.sort.field,
                    'direction': this.sort.desc ? 'desc' : 'asc'
                })
                .then(res => {
                    this.referrers = res.data.referrers.data;
                    this.revshare_commission_base = res.data.revshare_commission_base;
                    this.current_page = res.data.referrers.current_page;
                    this.last_page = res.data.referrers.last_page;
                    this.pagenav_links = res.data.referrers.links;

                    this.isLoading = false;
                });
            },
            getStats() {
                this.$root.axios.get('/api/referrals/info')
                    .then(res => {
                        this.commission = res.data.commission;
                        this.stats.total = res.data.total;
                        this.stats.range = res.data.range;
                        this.received_total_profit = res.data.received_total_profit;
                        this.received_range_profit = res.data.received_range_profit;
                        this.profit = res.data.profit;
                        this.captured_at = res.data.captured_at;
                        this.can_take_profit = res.data.can_take_profit;
                        this.loan = res.data.loan;
                        if(this.stats.total.referrers) {
                            this.getInfo();
                        }    

                        this.$root.isLoading = false;
                    });    
            },
			handlerSetPeriod(val) {
				let start = this.$root.moment(val[0]).format("YYYY-MM-DD")
				let end = this.$root.moment(val[1]).format("YYYY-MM-DD")
				this.getRangeStats(start, end);
				this.currentRange = null;
			},
            getRangeStats(start, end) {
                this.$root.axios.post('/api/referrals/stats', {
                    'start': start,
                    'end': end
                })
                .then(res => {
                    this.stats.range = res.data.range;
                    this.received_range_profit = res.data.received_range_profit;
                })
                .catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                }); 
            },
            getStatsForRange(range) {
                if(this.currentRange == range) {
                    return;
                }
				this.date = null;

                this.currentRange = range;
                this.start = this.end = '';
                let start,end;
				let currentDate  = new Date();

                switch (range) {
                    case 'yesterday':
                        start = this.$root.moment(currentDate).add(-1, 'days').format('YYYY-MM-DD');
                        end = this.$root.moment(currentDate).add(-1, 'days').format('YYYY-MM-DD');
                    break;
                    case 'today':
                        start = this.$root.moment(currentDate).format('YYYY-MM-DD');
                        end = this.$root.moment(currentDate).format('YYYY-MM-DD');
                    break;
                    case 'week':
                        start = this.$root.moment(currentDate).startOf('isoWeek').format('YYYY-MM-DD');
                        end = this.$root.moment(currentDate).endOf('isoWeek').format('YYYY-MM-DD');
                    break;
                    case 'month':
                        start = this.$root.moment(currentDate).startOf('month').format('YYYY-MM-DD');
                        end = this.$root.moment(currentDate).endOf('month').format('YYYY-MM-DD');
                    break;
                }

                this.getRangeStats(start, end);
            },
            refresh() {
                this.$root.axios.post('/api/referrals/revshare/refresh')
                    .then(res => {
                        const data = res.data;

                        this.$toast.success(data.message);

                        this.can_refresh = false;
                    })
                    .catch(error => {
                        this.$toast.error(this.$root.graphql.axiosGetError(error));
                    });
            },
            takeProfit() {
                this.$root.axios.post('/api/referrals/revshare/take')
                    .then(res => {
                        const data = res.data;

                        this.received_range_profit += this.profit;
                        this.received_total_profit += this.profit;
                        this.profit = 0;
                        this.user.balance = data.balance;
                        

                        this.can_take_profit = false;
                    })
                    .catch(error => {
                        this.$toast.error(this.$root.graphql.axiosGetError(error));
                    });
            },
            doSort(column) {
                this.sort = {
                    'field': column,
                    'desc': !this.sort.desc
                };

                this.isLoading = true;

                this.getInfo();
            },
            goToPage(pageUrl) {
                let url = new URL(pageUrl);
                this.page = url.searchParams.get('page');

                this.isLoading = true;

                this.getInfo();
            }
        },
        sockets: {
            revshare_refresh: function() {
                this.getStats();
            }
        }
    }
</script>